import {lazy} from './lazy.js';
import {getArgs} from './args.js';
import {doc} from './documentation.js';
doc(
    "snapshot",
    {
        "snapNumber": ""
    },
    "Go to snapshot given in argument"
);

export const snapshot = (i) => {
    return (...args) => {
        let {effect} = getArgs(args);
        let _i = lazy(i, ...args);
        effect.currentSnapshotParameter.set(_i);
        return {};
    };
};

doc(
    "nextSnapshot",
    {
    },
    "Go to next snapshot-- looping back to first snapshot if at the end."
);
export const nextSnapshot = () => {
    return (... args) => {
        let {effect} = getArgs(args);
        let current = effect.currentSnapshotParameter.get() || 0;
        effect.currentSnapshotParameter.set(
            (current + 1) % effect.snapshots.length);
        // return nothing because the snapshot change should take care of
        // that
        return {};
    };
};
doc(
    "interpolateSnapshot",
    {
        "snapshotNumber": "",
        "percentage" : "how much of the snapshot to use"
    },
    "Go to next snapshot-- looping back to first snapshot if at the end."
);
export const interpolateSnapshot = (snapshotNumber, percentage=50) => {
    return (... args) => {
        let {coords, effect} = getArgs(args);
        let _snapshotNumber = lazy(snapshotNumber, ...args);
        let _percentage = lazy(percentage, ...args);
        let snapshot = effect.snapshots[_snapshotNumber % effect.snapshots.length];
        if (!snapshot) { return coords; }

        // now we must tae the percentage of snapshot and interpolate it

        let snapshotPart = orderByDelta(snapshot, coords)
            .slice(0, Math.floor(snapshot.length * (_percentage / 50)));
        let _coords = {... coords};
        for (let {parameter, coordinates, min, max} of snapshotPart) {
            if (!(parameter.id in coords)) {
                continue;
            }

            // need to set the min/max
            if (min !== undefined && max !== undefined) {
                parameter.min = min;
                parameter.max = max;
            }
            _coords[parameter.id] = coordinates;
        }
        return _coords;
    };
};

const sq = (x) => x*x;
const sqrt = Math.sqrt;
const dist = (c1, c2) => {
    return sqrt(sq(c1.x - c2.x) + sq(c1.y - c2.y));
};

const orderByDelta = (snapshot, coords) => {
    snapshot = [... snapshot];
    return snapshot.filter(x => x.parameter.id in coords)
        .sort(
            (b,a) => 
                dist(a.coordinates, coords[a.parameter.id]) - 
                dist(b.coordinates, coords[b.parameter.id]));
};
